'use client';

import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getInfinityArticles } from '@/features/articles';
import { Topic } from '.';

interface TopicByKeyProps {
  type: string;
  title: string;
}

export const TopicByKey = ({ type, title }: TopicByKeyProps) => {
  const {
    isFetching,
    data: infinityArticles,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteQuery(
    getInfinityArticles({
      key: type,
      limit: 15,
    })
  );

  const articles = useMemo(() => {
    return infinityArticles?.pages.flatMap((page) => page.articles) ?? [];
  }, [infinityArticles]);

  return (
    <Topic
      title={title}
      articles={articles}
      onFetchMore={fetchNextPage}
      isFetching={isFetching}
      hasNextPage={hasNextPage}
    />
  );
};
